<div
  class="p-3 w-full rounded-lg cursor-pointer border border-smoke hover:border-smoke-darker transition-colors duration-200 container"
  [ngClass]="{
    'bg-grape-lighter': emphasize
  }">
  <div class="flex gap-2 justify-between items-center">
    <div class="flex flex-col gap-1 flex-1">
      @if (customHeadline) {
        <ng-content select="[stepTriggerCustomHeadline]"></ng-content>
      } @else {
        <div class="flex flex-row gap-4">
          <div class="strong text-grape-darker">{{ headline }}</div>
          <ui-badge *ngIf="new" variant="primary" appearance="solid" size="sm" value="New"></ui-badge>
          <ui-badge *ngIf="on" variant="success" appearance="solid" size="sm" value="On"></ui-badge>
        </div>
      }
      <div
        *ngIf="subline"
        class="text-sm truncate"
        [ngClass]="{ 'text-grape': emphasize, 'text-night': !emphasize }"
        [matTooltip]="subline">
        {{ subline }}
      </div>
    </div>
    <ui-icon
      [icon]="'griddy-chevron-right'"
      [size]="20"
      class="arrow"
      [ngClass]="{ 'text-grape': emphasize }"></ui-icon>
  </div>
</div>
